import React, { useContext, } from "react";
import { SimpleContextDropdown } from "./SimpleContextDropdown";
import { NavigationContext } from "../../contexts/NavigationContext";

export const ImplantSideSelect = ({ name, data }) => {
  const {
    objectOptions: { implantSide },
  } = useContext(NavigationContext);

  return (
    <SimpleContextDropdown name={name} value={data} options={implantSide} />
  );
};
